export default function ChallengesSection() {
  const challenges = [
    { icon: 'ri-emotion-sad-line', title: 'Stigma & Discrimination', desc: 'Deep-seated societal stigma leading to exclusion and marginalization of persons living with epilepsy.' },
    { icon: 'ri-question-mark', title: 'Lack of Awareness', desc: 'Widespread misinformation and poor understanding of the condition perpetuate fear and isolation.' },
    { icon: 'ri-hospital-line', title: 'Limited Access to Care', desc: 'Inadequate medication supply and insufficient medical support leave many without proper treatment.' },
    { icon: 'ri-ancient-gate-line', title: 'Cultural Misinformation', desc: 'Harmful myths and traditional beliefs hinder proper medical treatment and community acceptance.' },
    { icon: 'ri-file-damage-line', title: 'Policy Gaps', desc: 'Insufficient government attention and lack of comprehensive policy frameworks for epilepsy care.' },
    { icon: 'ri-map-2-line', title: 'Geographic Barriers', desc: 'Rural communities face extreme difficulty accessing specialists, medication, and support networks.' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=African%20child%20with%20epilepsy%20being%20cared%20for%20by%20a%20compassionate%20healthcare%20worker%20in%20a%20rural%20clinic%2C%20warm%20natural%20lighting%2C%20emotional%20and%20hopeful%20scene%2C%20documentary%20photography%2C%20authentic%20African%20healthcare%20setting%2C%20soft%20focus%20background&width=700&height=900&seq=challenge001&orientation=portrait"
                alt="Epilepsy challenges in Africa"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#7B2D8B] rounded-2xl p-6 max-w-[220px]">
              <div className="text-4xl font-extrabold text-white mb-1">80%</div>
              <div className="text-white/80 text-sm leading-snug">of people with epilepsy live in low-income countries</div>
            </div>
          </div>

          <div>
            <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B] mb-4 block">The Challenge</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              The Unseen Struggle of <strong>Epilepsy in Africa</strong>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-10">
              Epilepsy affects over <strong>50 million people globally</strong>, with a disproportionately high concentration in Africa. These challenges contribute to avoidable deaths, profound isolation, and a significantly diminished quality of life.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {challenges.map((item) => (
                <div key={item.title} className="flex gap-3 p-4 rounded-xl bg-[#FAF7FC] border border-purple-100">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#7B2D8B]/10 shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#7B2D8B] text-sm`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-800 text-sm mb-1">{item.title}</div>
                    <div className="text-gray-500 text-xs leading-relaxed">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
